import React from "react"
import { withTranslation } from 'react-i18next';
import { ReactComponent as LogoSVG } from '../../assets/images/logo.svg';
//const logo_image_white = require('../../assets/images/logo.svg'); // with require
import LanguageSwitcher from '../../components/LanguageSwitcher';
import Cookies from 'universal-cookie';

class MainNavigationBar extends React.Component {
    nav = React.createRef();
    backButtonVisible = "hide";
    MenuButtonStatus = ""
    menuContentVisible = "hide"

    constructor (props) {
        super(props)
        this.state = {
            'open': false,
            'menuVisible' : false
        }

        this.menuOpenVisible = "";
        this.MenuButtonStatus = ""

        if (window.location.pathname.indexOf('/deal/')>=0 || window.location.pathname.indexOf('/flight/')>=0) {
            this.MenuButtonStatus = "";
            this.headerStyle = 'fixed'
        } else {
            this.menuOpenVisible = "";
            this.MenuButtonStatus = "";
        }        

        // binding
        this.handleLogoClick = this.handleLogoClick.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this)
        this.hideMenu  = this.hideMenu.bind(this);
        this.trackMenuClick = this.trackMenuClick.bind(this)
        

    }

    trackMenuClick = (e, item_name) => {
        window.dataLayer = window.dataLayer || [];
        const event_name = 'MenuClick';
        console.log('GTM event: ' + event_name)
        window.dataLayer.push({
            event: event_name,
            name: item_name,
            'pageUrl': window.location,
            'pageTitle' : window.title,
        });
    }

    // F005: opt into the new (Vite) site — mirrors the invite banner.
    switchToNewSite = (e) => {
        e.preventDefault();
        const isAfnu = window.location.hostname.endsWith('afnu.co.il');
        new Cookies().set('_site', 'new', { path: '/', maxAge: 31536000, sameSite: 'lax', ...(isAfnu ? { domain: '.afnu.co.il', secure: true } : {}) });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'new_site_opt_in' });
        window.setTimeout(() => window.location.reload(), 150);
    }

    getLanguageAwareHomeUrl = () => {
        const { i18n } = this.props;
        const currentLang = i18n.language;

        // If Hebrew, just return root
        if (currentLang === 'he') {
            return '/';
        }

        // If Arabic, return language-aware URL based on environment
        if (currentLang === 'ar') {
            const hostname = window.location.hostname;
            const isDev = hostname.includes('localhost') || hostname.includes('afnu-dev');

            // Dev environment: use query parameter
            if (isDev) {
                return '/?lang=ar';
            }

            // Production/Staging: just return root (already on ar.domain)
            return '/';
        }

        return '/';
    }

    handleLogoClick = () => {
        window.dataLayer = window.dataLayer || [];
        const event_name = 'LogoClick';
        console.log('GTM event: ' + event_name)
        window.dataLayer.push({
            event: event_name,
            'pageUrl': window.location,
            'pageTitle' : window.title,
        });
    }

    hideMenu = (event) => {
        event.preventDefault()
        this.setState((prevState)=>({
            ...prevState,
            menuVisible: false
        }))
    }

    handleMenuButtonClick = (e) => {
        e.preventDefault()
        this.setState( (prevState) => { 
            return {'menuVisible':(!prevState.menuVisible)}
        });

        
        window.dataLayer = window.dataLayer || [];
        const event_name = 'MenuButtonClick';
        console.log('GTM event: ' + event_name)
        window.dataLayer.push({
            event: event_name,
            'pageUrl': window.location,
            'pageTitle' : window.title,
        });

    }

    handleMenuOpen = () => {
        this.setState({
            'menu-button-open' : false,
        })

    }

    handleMenuClose = () => {
        
    }

    handleSearch = (e) => {
        e.preventDefault(e)
        if (this.props?.hideSearch || !this.props?.openSearchWindow) {
            window.location = '/search'
        }
        this.props.openSearchWindow();
    }

    handleShare = (e) => {
        if (e) e.preventDefault();

        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'DealPageShareClick',
                pageUrl: window.location.href,
                pageTitle: document.title
            });
        } catch (error) {
            console.log('Error pushing to dataLayer', error);
        }
        
        if (navigator.share) {
            navigator.share({
              title: this.props.t('navigation.actions.shareTitle'),
              text: this.props.t('navigation.actions.shareTitle'),
              url: window.location.href,
            })
              .then(() => console.log('Successful share'))
              .catch((error) => console.log('Error sharing', error));
        } else {
            // Fallback: Copy to clipboard
            navigator.clipboard.writeText(window.location.href);
            alert(this.props.t('navigation.actions.linkCopied'));
        }

    }

    handleBack = (e) => {
        e.preventDefault()
        //console.log('clk');
        window.history.back();
    }

    render(){
        const { t } = this.props;

        return (
            <>
                <div className={'menu-content ' + (this.state.menuVisible?'':'hide')}>
                    <ul>
                        <li className="first-item menu-header-flex">
                            <div>{t('navigation.menu.title')}</div>
                            <div><LanguageSwitcher /></div>
                        </li>
                        {/*<li className="mobile-only"><a href="/">{t('navigation.topMenu.abroadDealsFlightAndHotel')}</a></li>*/}

                        {/*<li className="mobile-only"><a href="/last-minute">{t('navigation.topMenu.lastMinuteDeals')}</a></li>*/}
                        <li className="menu-new-site" style={{margin:'8px 12px',listStyle:'none'}}><a href="#" onClick={this.switchToNewSite} title={t('newWebsiteBanner.ctaAriaLabel')} tabIndex="1" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',background:'#ff7a00',color:'#fff',fontWeight:700,padding:'12px 16px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.25)',textDecoration:'none'}}><i className="fa fa-rocket fa-1x" /> {t('newWebsiteBanner.cta')} <span style={{background:'rgba(255,255,255,0.28)',borderRadius:'12px',padding:'2px 9px',fontSize:'11px',fontWeight:700}}>NEW</span></a></li>
                        <li><a href={this.getLanguageAwareHomeUrl()} title={t('navigation.menu.homeTitle')} tabIndex="1"><i className="fa fa-home fa-1x" /> {t('navigation.menu.home')}</a></li>
                        <li><a href="/search" title={t('navigation.menu.search')} tabIndex="1"><i className="fa fa-search fa-1x" /> {t('navigation.menu.search')}</a></li>
                        <li><a href="/article/about" title={t('navigation.menu.aboutTitle')} tabIndex="1"><i className="fa fa-graduation-cap fa-1x" /> {t('navigation.menu.about')}</a></li>
                        {/*<li><a href="/summer-deals/" className="menu-summer-deals-link"><FontAwesomeIcon icon={faSun} style={{color: 'yellow', fontSize: '1.3em',  margin: '0 0 0 0.3em'}} /> {t('navigation.topMenu.summerVacationEarlyBooking')}</a></li>*/}
                        <li><a href="/article/media" title={t('navigation.menu.mediaTitle')} tabIndex="1"><i className="fa fa-bullhorn fa-1x" /> {t('navigation.menu.media')}</a></li>
                        {/*<li><a href="/members/"><i className="fa fa-star fa-1x" /> {t('navigation.topMenu.vipClub')}</a></li>*/}
                        <li><a href="/article/faq" title={t('navigation.menu.faq')} tabIndex="1"><i className="fa fa-question fa-1x" /> {t('navigation.menu.faq')}</a></li>
                        <li><a href="/article/contact" title={t('navigation.menu.contact')} tabIndex="1"><i className="fa fa-phone fa-1x" /> {t('navigation.menu.contact')}</a></li>

                    </ul>
                </div>

                <div id="headerNav" className={'headerNav ' + this.headerStyle} ref={this.nav}>
                    <div className="nav-sections">

                        <div className="right-nav">

                            <a href="#" onClick={e=>{this.handleBack(e)}} title={t('navigation.actions.back')} className={this.backButtonVisible=='hide'?'hidden':''}>
                                <div className={"back " + this.backButtonVisible}>
                                <i className="fa fa-chevron-right fa-1x" /></div></a>

                            <a href="#" onClick={e=>{this.handleMenuButtonClick(e)}} title={this.state.menuVisible?t('navigation.menu.close'):t('navigation.menu.open')} tabIndex="1">
                                <div className={"menu-button " +  this.MenuButtonStatus + " "  } >
                                <i className={this.state.menuVisible?'fa fa-times fa-1x':'fa fa-bars fa-1x'} /></div></a>


                            
                        </div>

                        <div className='logo' onFocus={e=>{this.hideMenu(e)}}>
                                <a href={this.getLanguageAwareHomeUrl()} onClick={e=>{this.handleLogoClick(e)}} title={t('navigation.actions.backToHome')} tabIndex="2">
                                    <div id="logo">
                                        <LogoSVG className={"logo-svg"} title={t('navigation.actions.logo')}/>
                                    </div>
                                </a>
                            </div>

                        <div className="left-nav">
                            {(window.location.pathname.indexOf('/deal/')>=0) ? (
                                <a onClick={e=>{this.handleShare(e)}} title={t('navigation.actions.share')}><div className="share" tabIndex="2">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.803 5.33333C13.803 3.49238 15.3022 2 17.1515 2C19.0008 2 20.5 3.49238 20.5 5.33333C20.5 7.17428 19.0008 8.66667 17.1515 8.66667C16.2177 8.66667 15.3738 8.28596 14.7671 7.67347L10.1317 10.8295C10.1745 11.0425 10.197 11.2625 10.197 11.4872C10.197 11.9322 10.109 12.3576 9.94959 12.7464L15.0323 16.0858C15.6092 15.6161 16.3473 15.3333 17.1515 15.3333C19.0008 15.3333 20.5 16.8257 20.5 18.6667C20.5 20.5076 19.0008 22 17.1515 22C15.3022 22 13.803 20.5076 13.803 18.6667C13.803 18.1845 13.9062 17.7255 14.0917 17.3111L9.05007 13.9987C8.46196 14.5098 7.6916 14.8205 6.84848 14.8205C4.99917 14.8205 3.5 13.3281 3.5 11.4872C3.5 9.64623 4.99917 8.15385 6.84848 8.15385C7.9119 8.15385 8.85853 8.64725 9.47145 9.41518L13.9639 6.35643C13.8594 6.03359 13.803 5.6896 13.803 5.33333Z" fill="currentColor"/>
                                </svg>
                            </div></a>
                            ): (
                                <a onClick={e=>{this.handleSearch(e)}} title={t('navigation.menu.search')}><div className="search" tabIndex="2">
                                <i className="fa fa-search" /></div></a>
                            ) }


                        </div>
                    </div>

                    <nav className={"mobile_navigation " }>
                            <ul>
                                <li className={"menu_col1 " + this.props.activeMenu==='main'?'active':''}>
                                    <a href={this.getLanguageAwareHomeUrl()} onClick={e=>{this.trackMenuClick(e, 'homepage')}} title={t('navigation.topMenu.bestDealsTitle')} tabIndex="3">
                                        <i className="fa fa-plane fa-2x" />
                                        {t('navigation.mobileNav.cheapDeals').split(' ')[0]}<br />
                                    {t('navigation.mobileNav.cheapDeals').split(' ')[1]}</a></li>
                                <li className={"menu_col2 " + this.props.activeMenu==='weekends'?'active':''}>
                                    <a href="/weekends/"  onClick={e=>{this.trackMenuClick(e, 'weekends')}} title={t('navigation.topMenu.weekendsTitle')} tabIndex="3">
                                        <i className="fa fa-calendar fa-2x" />
                                        {t('navigation.mobileNav.weekends').split(' ')[0]}<br />
                                        {t('navigation.mobileNav.weekends').split(' ')[1]}</a></li>
                                {/*<li className={"menu_col3 " + this.props.activeMenu==='passover-vacation-deals'?'active':''}>
                                    <a href="/passover-vacation-deals/"  onClick={e=>{this.trackMenuClick(e, 'passover-vacation-deals')}} title={t('navigation.topMenu.passoverDealsTitle')} tabIndex="3">
                                        <i className="fa fa-calendar fa-2x" />
                                        {t('navigation.topMenu.passoverDeals')}</a></li>

                                <li className={"menu_col2 " + this.props.activeMenu==='summer-vacation'?'active':''}>
                                    <a href="/summer-vacation/"  onClick={e=>{this.trackMenuClick(e, 'weekends')}} title={t('navigation.topMenu.summerVacationDealsTitle')} tabIndex="3">
                                        <i className="fa fa-calendar fa-2x" />
                                        {t('navigation.topMenu.summerVacationDeals')}</a></li>
                                */}
                                <li className={"menu_col3 " + this.props.activeMenu==='holiday-season-deals'?'active':''}>
                                    <a href="/holiday-season-deals/"  onClick={e=>{this.trackMenuClick(e, 'holiday-season-deals')}} title={t('navigation.topMenu.holidaySeasonDealsTitle')} tabIndex="3">
                                        <i className="fa fa-calendar fa-2x" />
                                        {t('navigation.topMenu.holidaySeasonDeals')}</a></li>

                                {/*<li className={'menu_col5 vip ' + (this.props.activeMenu==='members'?'active':'')}>
                                    <a href="/members/"  onClick={e=>{this.trackMenuClick(e, 'vip')}}>
                                        <img src="/images/icons/vip.svg" alt="VIP" className="vip_icon" width="50" height="25"></img>
                                        {t('navigation.mobileNav.club')}<br />
                                        <span className="spn_vip">{t('navigation.mobileNav.vip')}</span>
                                </a></li>*/}
                            </ul>
                    </nav>
                    <div className="wrapper">
                        <div id="sidemenu_toggle" className="sidemenu_btn">
                            <span></span> <span></span> <span></span>
                        </div>
                        
                        <nav className="desktop_navigation">

                            <ul>
                                <li className={this.props.activeMenu==='main'?'active':''}>
                                    <a href="/best-deals/"  onClick={e=>{this.trackMenuClick(e, 'homepage')}} title={t('navigation.topMenu.bestDealsTitle')}>{t('navigation.topMenu.bestDeals')} </a></li>
                                <li className={this.props.activeMenu==='weekends'?'active':''}>
                                    <a href="/weekends/"  onClick={e=>{this.trackMenuClick(e, 'weekends')}} title={t('navigation.topMenu.weekendsTitle')}>{t('navigation.topMenu.weekends')}</a></li>
                                {/*<li className={this.props.activeMenu==='summer-vacation'?'active':''}>
                                    <a href="/summer-vacation/" onClick={e=>{this.trackMenuClick(e, 'summer-vacation')}} title={t('navigation.topMenu.summerVacationDealsTitle')}>{t('navigation.topMenu.summerVacationDeals')}</a></li>
                                */}
                                <li className={this.props.activeMenu==='passover-vacation-deals'?'active':''}>
                                    <a href="/passover-vacation-deals/" onClick={e=>{this.trackMenuClick(e, 'passover-vacation-deals')}} title={t('navigation.topMenu.passoverDealsTitle')}>{t('navigation.topMenu.passoverDeals')}</a></li>
		{/*
		<li className={this.props.activeMenu==='summer-deals'?'active':''}>
                                    <a href="/holiday-season-deals/" onClick={e=>{this.trackMenuClick(e, 'holiday-season-deals')}} title={t('navigation.topMenu.holidaySeasonDealsTitle')}>{t('navigation.topMenu.holidaySeasonDeals')}</a></li>
				    */}
                                {/*<li className={'members ' + (this.props.activeMenu==='vip'?'active':'')}>
                                    <a href="/members/" onClick={e=>{this.trackMenuClick(e, 'vip')}}>{t('navigation.topMenu.vipMembersClub')}</a></li>                                */}
                            </ul>
                        </nav>


                        <div id="connect">
                        </div>
                    </div>


                    <div className="overlay"></div>
                </div>
            </>
        )

    }
}
export default withTranslation()(MainNavigationBar)
